<template>
  <div>
    <modal>
      <h4 slot="title">
        {{ $t('verifyThePayment') }}
      </h4>
      <section slot="body">
        <div class="content">
          <img :src="require('@/assets/_desktop/_payments/redirect-pic.svg')" />
          <p>{{ $t('toVerifyPaymentYouWillBeTaken') }}</p>
          <button v-if="$parent.redirectUrl" class="clavo-button primary" @click="redirectToUrl">
            {{ $t('continue') }}
          </button>
        </div>
      </section>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'VerifyPaymentPopup',
  components: {
    Modal,
  },
  async created() {
    // console.log('dsa', this.$parent.redirectUrl)
    if (this.$parent.redirectUrl) {
      // await this.sleep(500) // remove delay
      window.location = this.$parent.redirectUrl
    }
  },
  methods: {
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    redirectToUrl() {
      window.location = this.$parent.redirectUrl
    },
  },
}
</script>

<style scoped lang="scss">
.content {
  text-align: center;
  img {
    margin-top: 18px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    width: 300px;
    margin: 30px auto 48px;
  }
  button {
    width: 300px;
    margin-bottom: 30px;
  }
}
</style>
